import {IncomingHttpHeaders} from "http"
import {getSettingsHeaders} from "@next/utils"
import {Store} from "@reduxjs/toolkit"
import {LANG_EN, LANGUAGE_HEADER, SITE_URL_HEADER} from "../../config/constants"
import env from "../../config/env"
import {RequestState} from "../../models/Request"

export const SET_REQUEST = "SET_REQUEST"
interface SetRequest {
    type: typeof SET_REQUEST
    request: any
}

type Actions = SetRequest

const initialState: RequestState = {
    headers: null as unknown as IncomingHttpHeaders,
    isEnglishLang: false,
    im: "",
    pageType: "",
    siteUrl: "",
}

export const setRequestAction = (store: Store, request: any) => {
    store.dispatch({
        type: SET_REQUEST,
        request: {
            headers: request.headers || {},
            query: request.query || {},
        },
    })
}

const reducer = (state: RequestState = initialState, action: Actions): RequestState => {
    switch (action.type) {
        case SET_REQUEST:
            return {
                ...state,
                headers: getSettingsHeaders(action.request.headers) as IncomingHttpHeaders,
                isEnglishLang:
                    action.request.headers &&
                    action.request.headers[LANGUAGE_HEADER] &&
                    action.request.headers[LANGUAGE_HEADER].toLowerCase() === LANG_EN,
                im: action.request.query.im ?? "",
                pageType: action.request.query.type ?? "",
                siteUrl: `${action.request.headers[SITE_URL_HEADER] as string}${env.REACT_APP_SERVE_PATH_PREFIX}`,
            }
        default:
            return state
    }
}

export default reducer
